export const ZedHP = {
  cyst: {
    Normal  : 75,
    Hard    : 100,
    Suicidal: 100,
    HOE     : 100,
    head    : {
      Normal  : 15,
      Hard    : 20,
      Suicidal: 20,
      HOE     : 20
    }
  },

  alphaClot: {
    Normal  : 75,
    Hard    : 100,
    Suicidal: 100,
    HOE     : 100,
    head    : {
      Normal  : 15,
      Hard    : 20,
      Suicidal: 20,
      HOE     : 20
    }
  },
  rioter: {
    Normal  : 225,
    Hard    : 100,
    Suicidal: 100,
    HOE     : 100,
    head    : {
      Normal  : 93,
      Hard    : 125,
      Suicidal: 125,
      HOE     : 125
    },
    armor: {
      head: {
        Normal  : 337,
        Hard    : 450,
        Suicidal: 450,
        HOE     : 450,
      },
      torso: {
        Normal  : 375,
        Hard    : 500,
        Suicidal: 500,
        HOE     : 500,
      }
    }
  },

  slasher: {
    Normal  : 75,
    Hard    : 100,
    Suicidal: 100,
    HOE     : 100,
    head    : {
      Normal  : 15,
      Hard    : 20,
      Suicidal: 20,
      HOE     : 20
    }
  },

  bloat: {
    Normal  : 303,
    Hard    : 405,
    Suicidal: 486,
    HOE     : 526,
    head    : {
      Normal  : 56,
      Hard    : 75,
      Suicidal: 78,
      HOE     : 82
    }
  },

  crawler: {
    Normal  : 41,
    Hard    : 55,
    Suicidal: 55,
    HOE     : 55,
    head    : {
      Normal  : 15,
      Hard    : 20,
      Suicidal: 20,
      HOE     : 20
    }
  },

  gorefast: {
    Normal  : 150,
    Hard    : 200,
    Suicidal: 200,
    HOE     : 200,
    head    : {
      Normal  : 37,
      Hard    : 50,
      Suicidal: 50,
      HOE     : 50
    }
  },

  gorefiend: {
    Normal  : 300,
    Hard    : 400,
    Suicidal: 400,
    HOE     : 400,
    head    : {
      Normal  : 112,
      Hard    : 150,
      Suicidal: 150,
      HOE     : 150
    }
  },

  stalker: {
    Normal  : 56,
    Hard    : 75,
    Suicidal: 75,
    HOE     : 75,
    head    : {
      Normal  : 15,
      Hard    : 20,
      Suicidal: 20,
      HOE     : 20
    }
  },

  husk: {
    Normal  : 346,
    Hard    : 462,
    Suicidal: 462,
    HOE     : 600,
    head    : {
      Normal  : 150,
      Hard    : 200,
      Suicidal: 200,
      HOE     : 220
    }
  },

  siren: {
    Normal  : 230,
    Hard    : 230,
    Suicidal: 230,
    HOE     : 230,
    head    : {
      Normal  : 155,
      Hard    : 155,
      Suicidal: 155,
      HOE     : 155

    }
  },

  edar: {
    Normal  : 581,
    Hard    : 775,
    Suicidal: 775,
    HOE     : 1007,
    head    : {
      Normal  : 262,
      Hard    : 350,
      Suicidal: 350,
      HOE     : 385
    },
    armor: {
      head: {
        Normal  : 168,
        Hard    : 225,
        Suicidal: 225,
        HOE     : 292,
      },
      torso: {
        Normal  : 450,
        Hard    : 600,
        Suicidal: 600,
        HOE     : 780,
      }
    }
  },
  scrake: {
    Normal1p: 935,
    Normal2p: 1299,
    Normal3p: 1664,
    Normal4p: 2028,
    Normal5p: 2393,
    Normal6p: 2758,
    Hard1p: 1100,
    Hard2p: 1529,
    Hard3p: 1958,
    Hard4p: 2387,
    Hard5p: 2816,
    Hard6p: 3245,
    Suicidal1p: 1210,
    Suicidal2p: 1681,
    Suicidal3p: 2153,
    Suicidal4p: 2625,
    Suicidal5p: 3097,
    Suicidal6p: 3569,
    HOE1p: 1210,
    HOE2p: 1681,
    HOE3p: 2153,
    HOE4p: 2625,
    HOE5p: 3097,
    HOE6p: 3569,
    head: {
      Normal1p: 510,
      Normal2p: 652,
      Normal3p: 795,
      Normal4p: 938,
      Normal5p: 1081,
      Normal6p: 1224,
      Hard1p: 600,
      Hard2p: 768,
      Hard3p: 936,
      Hard4p: 1104,
      Hard5p: 1272,
      Hard6p: 1440,
      Suicidal1p: 630,
      Suicidal2p: 806,
      Suicidal3p: 982,
      Suicidal4p: 1159,
      Suicidal5p: 1335,
      Suicidal6p: 1512,
      HOE1p: 660,
      HOE2p: 844,
      HOE3p: 1029,
      HOE4p: 1214,
      HOE5p: 1399,
      HOE6p: 1584
    }
  },
  quarter: {
    Normal1p: 375,
    Normal2p: 450,
    Normal3p: 525,
    Normal4p: 600,
    Normal5p: 675,
    Normal6p: 750,
    Hard1p: 562,
    Hard2p: 674,
    Hard3p: 786,
    Hard4p: 899,
    Hard5p: 1011,
    Hard6p: 1124,
    Suicidal1p: 825,
    Suicidal2p: 990,
    Suicidal3p: 1155,
    Suicidal4p: 1320,
    Suicidal5p: 1485,
    Suicidal6p: 1650,
    HOE1p: 862,
    HOE2p: 1034,
    HOE3p: 1206,
    HOE4p: 1379,
    HOE5p: 1551,
    HOE6p: 1724,
    head: {
      Normal1p: 325,
      Normal2p: 373,
      Normal3p: 422,
      Normal4p: 471,
      Normal5p: 520,
      Normal6p: 568,
      Hard1p: 487,
      Hard2p: 560,
      Hard3p: 633,
      Hard4p: 706,
      Hard5p: 779,
      Hard6p: 852,
      Suicidal1p: 682,
      Suicidal2p: 784,
      Suicidal3p: 886,
      Suicidal4p: 988,
      Suicidal5p: 1091,
      Suicidal6p: 1193,
      HOE1p: 702,
      HOE2p: 807,
      HOE3p: 912,
      HOE4p: 1017,
      HOE5p: 1123,
      HOE6p: 1228
    }
  },
  fleshpound: {
    Normal1p: 1125,
    Normal2p: 1563,
    Normal3p: 2002,
    Normal4p: 2441,
    Normal5p: 2880,
    Normal6p: 3318,
    Hard1p: 1500,
    Hard2p: 2085,
    Hard3p: 2670,
    Hard4p: 3355,
    Hard5p: 3840,
    Hard6p: 4425,
    Suicidal1p: 1650,
    Suicidal2p: 2293,
    Suicidal3p: 2937,
    Suicidal4p: 3580,
    Suicidal5p: 4224,
    Suicidal6p: 4867,
    HOE1p: 1800,
    HOE2p: 2502,
    HOE3p: 3204,
    HOE4p: 3906,
    HOE5p: 4608,
    HOE6p: 5310,
    head: {
      Normal1p: 487,
      Normal2p: 623,
      Normal3p: 759,
      Normal4p: 896,
      Normal5p: 1032,
      Normal6p: 1168,
      Hard1p: 650,
      Hard2p: 832,
      Hard3p: 1014,
      Hard4p: 1196,
      Hard5p: 1378,
      Hard6p: 1560,
      Suicidal1p: 682,
      Suicidal2p: 872,
      Suicidal3p: 1063,
      Suicidal4p: 1254,
      Suicidal5p: 1445,
      Suicidal6p: 1636,
      HOE1p: 715,
      HOE2p: 915,
      HOE3p: 1115,
      HOE4p: 1315,
      HOE5p: 1515,
      HOE6p: 1716,
    }

  }

};


// WEBPACK FOOTER //
// ./src/pages/ZED/ZedHP.js